import { DisplayApplication } from "lib/display/display_application";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import get_all_content_by_prefix, {
  GetAllContentByPrefixResponse,
} from "lib/worker/api/get_all_content_by_prefix";
import get_vender_domain_infomation, {
  GetVenderDomainInfomationResponse,
} from "lib/worker/api/get_vender_domain_infomation";
import { GetServerSideProps } from "next";
import LayoutMaster from "../components/layout/layout_master";

interface HowToHomeScreenProps {
  isIOS: String;
  isMobileView: String;
  isLine: String;
  venderInfomation: GetVenderDomainInfomationResponse;
  content: GetAllContentByPrefixResponse[];
  infomation: CheckWithPrefixResponse;
}

export default function HowToHomeScreen(props: HowToHomeScreenProps) {
  const isIOS = props.isIOS;
  const isLine = props.isLine;
  const isMobileView = props.isMobileView;

  return (
    <LayoutMaster
      content_setting={{
        title: "download application",
        description: "application เข้าเล่นง่าย สามารถโหลดได้พี่ 4 ขั้นตอน",
      }}
      information={props.infomation}
    >
      {DisplayApplication(isLine, isMobileView, isIOS, props.content)}
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  const venderInfomation = await get_vender_domain_infomation({
    domain: infomation.domain,
  });
  let isIOS = (context.req.headers["user-agent"] as string).match(
    /iPhone|iPad|iPod/i
  );

  let isLine = (context.req.headers["user-agent"] as string).match(/Line/i);

  let isMobileView = (context.req.headers["user-agent"] as string).match(
    /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
  );

  const content = await get_all_content_by_prefix({
    prefix: infomation.prefix,
  });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      venderInfomation: venderInfomation,
      isIOS: Boolean(isIOS),
      isMobileView: Boolean(isMobileView),
      isLine: isLine,
      content: content,
      infomation: infomation,
    },
  };
};
